import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaUtensils, FaHome } from "react-icons/fa";

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen px-6 bg-gradient-to-br from-orange-50 to-yellow-50 relative overflow-hidden">
            {/* Floating Roti Elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-20 left-10 w-8 h-8 bg-orange-200 rounded-full animate-bounce" style={{ animationDelay: '0s', animationDuration: '3s' }}></div>
                <div className="absolute top-40 right-20 w-6 h-6 bg-yellow-300 rounded-full animate-bounce" style={{ animationDelay: '1s', animationDuration: '2.5s' }}></div>
                <div className="absolute bottom-32 left-20 w-10 h-10 bg-orange-300 rounded-full animate-bounce" style={{ animationDelay: '2s', animationDuration: '3.5s' }}></div>
                <div className="absolute bottom-20 right-10 w-7 h-7 bg-yellow-200 rounded-full animate-bounce" style={{ animationDelay: '0.5s', animationDuration: '2.8s' }}></div>
                <div className="absolute top-1/2 left-5 w-5 h-5 bg-orange-400 rounded-full animate-bounce" style={{ animationDelay: '1.5s', animationDuration: '3.2s' }}></div>
                <div className="absolute top-1/3 right-5 w-9 h-9 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '2.5s', animationDuration: '2.7s' }}></div>
            </div>

            {/* Main Content */}
            <div className="text-center z-10 animate-fadeIn">
                

                {/* Big 404 with Animation */}
                <h1 className="text-[120px] md:text-[150px] font-extrabold text-transparent bg-gradient-to-r from-orange-500 to-yellow-600 bg-clip-text drop-shadow-lg animate-pulse mb-4">
                    404
                </h1>

                {/* Animated Message */}
                <div className="animate-slideInUp">
                    <h2 className="text-3xl md:text-4xl text-darktext font-bold mb-4 animate-wiggle">
                        Oops! This Rotiey Went Missing! 🥞
                    </h2>
                    <p className="text-lg text-contentcolor mb-8 text-center max-w-xl animate-fadeIn" style={{ animationDelay: '0.5s' }}>
                        Looks like this page got eaten! Don't worry, we have plenty more delicious content waiting for you.
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-slideInUp" style={{ animationDelay: '1s' }}>
                    <Link
                        to="/"
                        className="flex items-center gap-2 bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 shadow-lg transform hover:scale-105 hover:shadow-xl"
                    >
                        <FaHome className="animate-bounce" /> Back to Home
                    </Link>
                    <Link
                        to="/menu"
                        className="flex items-center gap-2 bg-white hover:bg-gray-50 text-orange-600 border-2 border-orange-500 px-8 py-4 rounded-full font-semibold transition-all duration-300 shadow-lg transform hover:scale-105 hover:shadow-xl"
                    >
                        <FaUtensils className="" /> Browse Menu
                    </Link>
                </div>

                {/* Fun Message */}
                <div className="mt-12 animate-fadeIn" style={{ animationDelay: '1.5s' }}>
                    <p className="text-sm text-gray-500 italic">
                        "Even our rotis don't go missing this often!" 😄
                    </p>
                </div>
            </div>

            {/* CSS Animations */}
            <style jsx>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideInUp {
                    from { opacity: 0; transform: translateY(50px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes wiggle {
                    0%, 7%, 14%, 21%, 28%, 35%, 42%, 49%, 56%, 63%, 70%, 77%, 84%, 91%, 98%, 100% {
                        transform: translateX(0);
                    }
                    3.5%, 10.5%, 17.5%, 24.5%, 31.5%, 38.5%, 45.5%, 52.5%, 59.5%, 66.5%, 73.5%, 80.5%, 87.5%, 94.5% {
                        transform: translateX(-2px);
                    }
                }
                @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                .animate-fadeIn { animation: fadeIn 0.8s ease-out; }
                .animate-slideInUp { animation: slideInUp 0.8s ease-out; }
                .animate-wiggle { animation: wiggle 2s infinite; }
                .animate-spin-slow { animation: spin-slow 4s linear infinite; }
            `}</style>
        </div>
    );
};

export default NotFound;